import React, { useEffect, useState } from "react";
import ReactToPrint from "react-to-print";
import "./styling.css"
import { InputLabel, Select, MenuItem, FormControl } from '@mui/material';
import companylogo from "../../assets/company.png"
// import axios from 'axios'
// import { Link } from "react-router-dom"
// import { toDate } from "date-fns";

const Report = ({ rowData }) => {
    const [fromDate, setFromDate] = useState("")
    const [toDate, setToDate] = useState("")

    const componentRef = React.createRef();

    const [clientData, setClientData] = useState([]);

    const [originalClientData, setOriginalClientData] = useState([]);
    useEffect(() => {

        const fetchClientData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/accounts/all_accounts`);
                const responseData = await response.json();
                if (responseData) {
                    const allData = responseData.client.filter((data) => data.clientid === rowData.id.toString());
                    setClientData(allData);
                    setOriginalClientData(allData);
                }
            } catch (error) {
                console.log(error.message);
            }
        };


        fetchClientData();
    }, []);

    const [openingBal, setOpeningBal] = useState(0)

    useEffect(() => {
        
        originalClientData.map((data)=>{
            // Original date string
            const dateString = data.date;

            // Parse the string into a Date object
            const originalDate = new Date(dateString);

            // Remove the time part by setting hours, minutes, seconds, and milliseconds to 0
            originalDate.setUTCHours(0, 0, 0, 0);

            // Convert back to ISO string format
         const convertedDateString = originalDate.toISOString().split('T')[0]; // Extracting date part only

            data.date=convertedDateString
        })

        if (fromDate) {
            let found = false; // Flag to track if a match is found
            for (let index = 0; index < originalClientData.length; index++) {
                if (originalClientData[index].date===fromDate) {
                    found = true;
                    if (index > 0) {
                        setOpeningBal(originalClientData[index - 1].Balance);
                    }
                    else {
                        setOpeningBal(0)
                    }
                    break; // Stop the loop after finding the first match
                }
            }
            if (!found) {
                // Handle case where no match is found
                setOpeningBal(0)
            }
        }

        const filteredData = originalClientData.filter(
            (data) =>
                new Date(data.date) >= new Date(fromDate) &&
                new Date(data.date) <= new Date(toDate)
        );
        setClientData(filteredData);
    }, [fromDate, toDate]);

    const formatDate = (dateString) => {
        const dateObject = new Date(dateString);
        const day = ('0' + dateObject.getDate()).slice(-2);
        const month = dateObject.toLocaleString('default', { month: 'short' });
        const year = dateObject.getFullYear().toString().slice(-2);
        return `${day}-${month}-${year}`;
    };



    return (
        <>
            <main
                className="m-5 p-5 xl:grid grid-cols-2 gap-10 xl:items-start"
                style={{
                    maxWidth: "1920px",
                    margin: "auto",
                }}
            >
                <section>
                    <div className="bg-white p-5 rounded shadow">
                        <div className="flex flex-col justify-center">
                            <InputLabel>From Date</InputLabel>
                            <FormControl>
                                <input type="date" onChange={(e) => setFromDate(e.target.value)} />
                            </FormControl>
                            <InputLabel>To Date</InputLabel>
                            <FormControl>
                                <input type="date" onChange={(e) => setToDate(e.target.value)} />
                            </FormControl>

                            <ReactToPrint
                                trigger={() => (
                                    <button className="bg-green-500 ml-5 text-white font-bold py-2 px-4 rounded hover:bg-green-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-green-400">
                                        Generate Report
                                    </button>
                                )}
                                content={() => componentRef.current}
                            />
                        </div>
                    </div>
                </section>

                {/* Invoice Preview */}
                <div className="invoice__preview bg-white p-5 rounded-2xl border-4 border-blue-200  ">
                    <ReactToPrint
                        trigger={() => (
                            <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                                Print / Download
                            </button>
                        )}
                        content={() => componentRef.current}
                    />
                    <div ref={componentRef} className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative">
                        <div className="">
                            <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                                <div>

                                    <img className="transform scale-[110%]" src={companylogo} alt="logo" />
                                </div>
                            </div>
                            <div className=" flex justify-between my-5">
                                <article className=" flex items-start justify-start">
                                    <ul>
                                        <li className="p-1 ">
                                            <span className="font-bold">Address:</span> {rowData.address}
                                        </li>
                                        <li className="p-1 ">
                                            <span className="font-bold">To: </span>{rowData.companyname}
                                            <p className="font-semibold">Name: </p><span>{rowData.firstname + ' ' + rowData.lastname}</span>
                                            <p className="font-semibold italic">Phone: </p><span>{rowData.phone}</span>
                                        </li>
                                    </ul>
                                </article>
                                <article className=" flex flex-col gap-2 items-start justify-end rounded-lg border border-black px-3 py-3">
                                    <h2 className=" font-bold">Statements of Accounts (Period)</h2>
                                    <ul>
                                        <li className=" ">
                                            <span className="">From Date:</span> {fromDate ? formatDate(new Date(fromDate)) : ''}
                                        </li>
                                        <li className=" ">
                                            <span className="">To Date:</span> {toDate ? formatDate(new Date(toDate)) : ''}
                                        </li>

                                    </ul>
                                </article>
                            </div>

                            <table width="100%" className="mb-10 ">
                                <thead>
                                    <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                                        <td className="font-bold">DATE</td>
                                        <td className="font-bold">DOC NO</td>
                                        <td className="font-bold">NARRATION</td>
                                        <td className="font-bold">DEBIT</td>
                                        <td className="font-bold">credit</td>
                                        <td className="font-bold">balance</td>
                                    </tr>
                                </thead>
                                {clientData && clientData.length > 0 ? (
                                    <tbody>
                                        <tr className=" text-center  h-10 font-bold rounded-xl border border-black">
                                            <td></td>
                                            <td></td>
                                            <td>Opening Balance as on  {fromDate ? formatDate(new Date(fromDate)) : ''}</td>
                                            <td></td>
                                            <td></td>
                                            <td>{openingBal}</td>

                                        </tr>
                                        {clientData.map(({ date, docid, description, debit, credit, Balance }, index) => {

                                            const formattedDate = formatDate(date);

                                            return (
                                                <tr key={docid} className="h-10">
                                                    <td>{formattedDate}</td>
                                                    <td>{docid}</td>
                                                    <td>{description}</td>
                                                    <td>{parseFloat(credit).toLocaleString()}</td>
                                                    <td>{parseFloat(debit).toLocaleString()}</td>
                                                    <td>{parseFloat(Balance).toLocaleString()}</td>
                                                </tr>
                                            );
                                        })}

                                        <tr className=" text-center h-10 font-bold rounded-xl border border-black">
                                            <td></td>
                                            <td></td>
                                            <td>Transaction Totals:</td>
                                            <td className="underline">{parseFloat(Math.round(clientData.reduce((total, { credit }) => total + parseFloat(credit || 0), 0))).toLocaleString()}</td>
                                            <td className="underline">{parseFloat(Math.round(clientData.reduce((total, { debit }) => total + parseFloat(debit || 0), 0))).toLocaleString()}</td>
                                            <td> = {
                                                (parseFloat(Math.round(clientData.reduce((total, { credit }) => total + parseFloat(credit || 0), 0)))-
                                                parseFloat(Math.round(clientData.reduce((total, { debit }) => total + parseFloat(debit || 0), 0)))).toLocaleString()
                                                }</td>
                                        </tr>

                                        <tr className=" text-center  h-14 font-bold mt-2 ">
                                            <td></td>
                                            <td></td>
                                            <td>Closing Balance as on {toDate ? formatDate(new Date(toDate)) : ''}</td>
                                            <td></td>
                                            <td></td>
                                            <td className="underline text-center">{parseFloat(clientData[clientData.length - 1].Balance).toLocaleString()}</td>

                                        </tr>

                                        <tr className=" text-center h-10 font-bold mt-2 ">
                                            <td className=" font-bold text-lg border-t border-black text-center" colSpan={2}>Accountant</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td ></td>
                                        </tr>
                                    </tbody>
                                ) : (
                                    <p className="mx-auto">No data available</p>
                                )}
                            </table>

                        </div>

                        {/* <footer className= "  border-t-2 border-gray-300 pb-5  w-full">
                            <div className=" w-full flex justify-evenly pt-4 pb-14 px-5 border-b border-gray-300 mb-2 text-base">
                                <p>Prepared By</p>
                                <p>Approved By</p>
                                <p>Salesman</p>
                                <p className=" ">Reciever's Name & Signature </p>
                                <p>Store Keeper</p>

                            </div>
                            <ul className="flex flex-wrap items-center gap-2 justify-center">
                                <li>
                                    <span className="font-bold">Email:</span> {"arcoglassqatar@gmail.com"}
                                </li>
                                <li>
                                    <span className="font-bold">Tel:</span> {"4460 5198"}<span className="ml-1 font-bold">-Fax:</span> {"4451 7172"}
                                </li>
                                <li>
                                    <span className="font-bold">P.O Box:</span> {"40992, Doha-Qatar "}
                                </li>
                            </ul>
                            <p className="text-center px-5 mt-4 text-xs ">
                            Thankyou for your purchase!
                        </p>
                        </footer> */}

                    </div>
                </div>

            </main>
        </>
    )
}

export default Report